<div class="progress-bar-items">
  @for (bar of bars; track $index) {
    <div class="progress-bar-item" [style.background-color]="bar"></div>
  }
</div>
